import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';

export default function Login() {
    const navigate = useNavigate();

    // States for login
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    // States for checking errors
    const [error, setError] = useState('');
    // Handling the form submission
    const handleSubmit = (event) => {
        event.preventDefault();
            // Handling the login logic
            try {
                // Assuming you have the authenticate function
              navigate('/admin');
            } catch {
              setError('Invalid username or password');
            } 
    };

    return (
      <div className="bg-black h-screen">
        {/*
          This example requires updating your template:
  
          ```
          <html class="h-full bg-white">
          <body class="h-full">
          ```
        */}
        <div className="flex min-h-full flex-1 flex-col justify-center px-6 pb-12 lg:px-8 bg-black">
          <div className="sm:mx-auto sm:w-full sm:max-w-sm">
            <h2 className="mt-10 text-center text-4xl font-bold leading-9 tracking-tight text-white">
              Rokasa Dashboard
            </h2>
            <p className="text-white text-center text-xl">Bienvenue</p>
          </div>
  
          <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm shadow p-5 rounded-lg bg-white">
            {/* <div className="text-center py-5">
                <p className="font-semibold text-xl">Bienvenue</p>
            </div> */}
            <form className="space-y-6" onSubmit={handleSubmit}>
              <div>
                <label htmlFor="email" className="block text-sm font-medium leading-6 text-gray-900">
                  E-mail
                </label>
                <div className="mt-2">
                  <input
                    id="email"
                    name="email"
                    type="email"
                    placeholder="nom@gmail.com" 
                    autoComplete="email"
                    value={email} onChange={(e) => setEmail(e.target.value)}
                    // required
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-black sm:text-sm sm:leading-6"
                  />
                </div>
              </div>
  
              <div>
                <div className="flex items-center justify-between">
                  <label htmlFor="password" className="block text-sm font-medium leading-6 text-gray-900">
                    Mot de passe
                  </label>
                  <div className="text-sm">
                    <a href="#" className="font-semibold text-black hover:text-gray-700">
                    Mot de passe oublié?
                    </a>
                  </div>
                </div>
                <div className="mt-2">
                  <input
                    id="password"
                    name="password"
                    type="password"
                    placeholder="••••••••" 
                    autoComplete="password"
                    value={password} onChange={(e) => setPassword(e.target.value)}
                    // required
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-black sm:text-sm sm:leading-6"
                  />
                </div>
              </div>

              {error && <p className='text-red-600 text-sm'>{error}</p>}

              <div className="flex items-start">
                      <div className="flex items-center h-5">
                        <input id="terms" aria-describedby="terms" type="checkbox" class="w-4 h-4 border text-black border-gray-300 rounded bg-gray-50 focus:ring-3 focus:ring-gray-300  " required=""/>
                      </div>
                      <div class="ml-3 text-sm">
                        <label for="terms" className=" text-gray-500">Se souvenir de moi</label>
                      </div>
                </div>
  
              <div>
                <button
                  type="submit"
                  className="flex w-full justify-center rounded-md bg-black px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-gray-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-700"
                >
                  Se connecter
                </button>
              </div>
            </form>
  
          </div>
        </div>
      </div>
    )
  }
  